import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import breadcrumbArrowBlack from "../../resources/icons/breadcrumbArrowBlack.svg";
import breadcrumbArrowGray from "../../resources/icons/breadcrumbArrowGray.svg";
import CurrencyIcon from "../../resources/icons/money.svg";
import AuthContext from "../../store/auth-context";
import WarningIcon from "../../resources/icons/warning-triangle.svg";
import { useTranslation } from "react-i18next";

const CfBreadcrumb = ({
  breadcrumbItems,
  isToggleOn,
  setIsToggleOn,
  creditCount,
  isPostPaid,
  hasFormFields,
  testId = "cf-breadcrumb",
}) => {
  const { t } = useTranslation();
  const authContext = useContext(AuthContext);

  return (
    <nav
      id={testId}
      className={`${
        isPostPaid
          ? "ls afa afp alj h-[4rem] bg-cfBreadcrumbBG"
          : "flex flex-col md:flex-row ls afa afp alj h-[8rem] md:h-[4rem] md:justify-between bg-cfBreadcrumbBG"
      }`}
      aria-label="Breadcrumb"
    >
      <ol
        className={`${
          isPostPaid
            ? "flex w-full md:w-[44%] pl-4"
            : "flex justify-between h-[4rem] w-full md:w-[43%] pl-4"
        }`}
      >
        <div className="flex w-full min-w-0 items-center justify-between gap-3">
          <div className="flex min-w-0 flex-wrap items-center gap-y-1">
            <li key="home" className="ls" id={`${testId}-item-home`}>
              <div className="ls yu">
                <NavLink
                  to={"/designs"}
                  id={`${testId}-link-templates`}
                  className="axk bks hover:no-underline"
                >
                  <span className="text-cfTextBreadcrumbDisabled">
                    {t("designs:templates")}
                  </span>
                </NavLink>
              </div>
            </li>

            {breadcrumbItems.map((item) => (
              <li
                key={item.to}
                id={`${testId}-item-${item.to.replace(/[/?&#]+/g, "-").replace(/^-+|-+$/g, "")}`}
                className="ls"
              >
                <div className="ls yu">
                  <img
                    src={
                      window.location.pathname === item.to
                        ? breadcrumbArrowBlack
                        : breadcrumbArrowGray
                    }
                    alt=""
                  />
                  <NavLink
                    to={item.to}
                    id={`${testId}-link-${item.to.replace(/[/?&#]+/g, "-").replace(/^-+|-+$/g, "")}`}
                    className={`js avv hover:no-underline ${
                      window.location.pathname === item.to
                        ? "font-bold text-cfTextBreadcrumbActive hover:text-cfTextNavbarActive"
                        : "text-cfTextNavbarDisabled"
                    }`}
                  >
                    {t(item.titleKey)}
                  </NavLink>
                </div>
              </li>
            ))}
          </div>
          {hasFormFields && (
            <label
              htmlFor={`${testId}-toggle-prefill`}
              className="flex shrink-0 items-center gap-2 mb-0 pr-4 cursor-pointer select-none"
            >
              <input
                type="checkbox"
                id={`${testId}-toggle-prefill`}
                checked={isToggleOn}
                onChange={() => setIsToggleOn((prev) => !prev)}
                className="sr-only peer"
              />
              <div className="relative w-11 h-6 shrink-0 bg-gray-200 peer-focus-visible:ring-2 peer-focus-visible:ring-cfPrimaryLight peer-focus-visible:ring-offset-2 rounded-full peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cfPrimaryLight transition-colors"></div>
              <span className="font-medium text-slate-700">
                {t("designs:prefill")}
              </span>
            </label>
          )}
        </div>
      </ol>
      {!isPostPaid &&
        (creditCount === 1 ? (
          <div className="flex justify-center self-start md:self-auto bg-white ml-[1rem] sm:ml-[1.7rem] md:ml-[0rem] mr-[0rem] md:mr-[2.8rem] gap-2 mt-[0.5rem] mb-[0.5rem] min-w-[220px] rounded-lg shadow-gray-500 shadow-md px-2 py-1 md:py-0">
            <img src={CurrencyIcon} height={28} width={28} alt="Credits" />
            <div className="flex items-center gap-2">
              <div className="font-bold text-cfPrimaryLight text-[24px]">
                {creditCount}
              </div>
              <div className="font-semibold text-[#4F5768]">
                {" "}
                {t("designs:credits_will_be_used")}
              </div>
            </div>
          </div>
        ) : creditCount === "Insufficient Credits" ||
          authContext.creditCount === "Insufficient Credits" ? (
          <div className="flex justify-center self-start md:self-auto bg-[#FFCBCB] ml-[1rem] sm:ml-[1.7rem] md:ml-[0rem] mr-[0rem] md:mr-[2.8rem] gap-2 mt-[0.5rem] mb-[0.5rem] min-w-[220px] rounded-lg shadow-gray-500 px-2 py-2 md:py-0">
            <img src={WarningIcon} height={30} width={30} alt="Warning" />
            <div className="flex items-center gap-2">
              <div className="font-semibold text-[#D92D20] text-[18px]">
                {t("designs:insufficient_credits")}
              </div>
              {/* <div className="bg-cfPrimaryButton cursor-pointer px-[0.32rem] py-[0.45rem] rounded-[7px] text-[13px] font-semibold text-white">
              Buy Credits
            </div> */}
            </div>
          </div>
        ) : (
          authContext.isFileUploaded && (
            <div className="flex justify-center self-start md:self-auto bg-white ml-[1rem] sm:ml-[1.7rem] md:ml-[0rem] mr-[0rem] md:mr-[2.8rem] gap-2 mt-[0.5rem] mb-[0.5rem] min-w-[220px] rounded-lg shadow-gray-500 shadow-md px-2 py-1 md:py-0">
              <img src={CurrencyIcon} height={28} width={28} alt="Credits" />
              <div className="flex items-center gap-2">
                <div className="font-bold text-cfPrimaryLight text-[24px]">
                  {creditCount}
                </div>
                <div className="font-semibold text-[#4F5768]">
                  {" "}
                  {t("designs:credits_will_be_used")}
                </div>
              </div>
            </div>
          )
        ))}
    </nav>
  );
};

export default CfBreadcrumb;
